import type { KeyboardViewport } from "~/helpers/aiChat/ferniePanelSizing";

import { useEffect, useState } from "react";

const readKeyboardViewport = (): KeyboardViewport | null => {
	const viewport = typeof window === "undefined" ? undefined : window.visualViewport;
	if (!viewport) {
		return null;
	}
	return { height: viewport.height, offsetTop: viewport.offsetTop };
};

const useMobileKeyboardViewport = (active: boolean): KeyboardViewport | null => {
	const [keyboardViewport, setKeyboardViewport] = useState<KeyboardViewport | null>(() =>
		active ? readKeyboardViewport() : null
	);

	useEffect(() => {
		if (!active) {
			setKeyboardViewport(null);
			return;
		}

		const viewport = window.visualViewport;
		if (!viewport) {
			return;
		}

		const update = () => setKeyboardViewport(readKeyboardViewport());
		update();
		viewport.addEventListener("resize", update);
		viewport.addEventListener("scroll", update);
		return () => {
			viewport.removeEventListener("resize", update);
			viewport.removeEventListener("scroll", update);
		};
	}, [active]);

	return keyboardViewport;
};

export default useMobileKeyboardViewport;
